import React from "react";
import { Trans, withTranslation } from "react-i18next";
import i18n from "../../../i18n";

import {
  Tag,
  Callout,
  Classes,
  Button,
  Alert,
  FormGroup,
  InputGroup,
  MenuItem
} from "@blueprintjs/core";
import {
  Table2,
  Cell,
  Column,
  ColumnHeaderCell,
  RowHeaderCell
} from "@blueprintjs/table";
import { Select } from "@blueprintjs/select";

import {
  authenticatedPutFetch,
  authenticatedGetFetch
} from "../../../utils/AuthenticatedFetch";
import Title from "../../Structure/logo";


const maxEvent = 710;

class EventFiltersSetting extends React.Component {
  constructor(props) {
    super();

    const eventLookup = {};
    for (let i = 0; i < maxEvent; i++)
      eventLookup[i] = i18n.t("event" + i);

    this.state = {
      events: [],
      allowed: localStorage.getItem('perm_admin') === "true",
      eventLookup: eventLookup,
      edit: -1,
      editing: false,
      edit_display: "true",
      edit_intent: "primary",
      text_filter: ""
    };
    this.tableRef = React.createRef();
  }

  componentDidMount() {
    authenticatedGetFetch("/events",
      (response) => {
        this.setState({ events: response.data });
      });
  }

  renderName(name) {
    return <div className={Classes.TEXT_LARGE}><strong>{name}</strong></div>;
  }


  render() {
    const data = this.state.events.filter((event) => this.state.eventLookup[event.id]?.toUpperCase().includes(this.state.text_filter.toUpperCase()));

    return <div>
      <Title text={<Trans>event flow customization</Trans>} closable={true}/>
      {
        this.state.allowed ?
          <div>
            <FormGroup inline={true} label={<Trans>search</Trans>} labelFor="text_filter">
              <InputGroup leftIcon="search" id="text_filter" value={this.state.text_filter} onChange={(filter) => this.setState({ text_filter: filter.target.value })} />
            </FormGroup>
            <div style={{ height: "75vh" }}>
              <Table2
                cellRendererDependencies={[data]}
                numRows={data.length}
                rowHeaderCellRenderer={(rowIndex) => <RowHeaderCell index={rowIndex} name={data[rowIndex]["id"]} />}
              >
                {/* label */}
                <Column
                  id="label"
                  cellRenderer={(rowIndex) => <Cell>{i18n.t("event" + data[rowIndex]["id"])}</Cell>}
                  columnHeaderCellRenderer={() => <ColumnHeaderCell name={<Trans>label</Trans>} nameRenderer={this.renderName} />}
                />

                {/* display
                <Column
                  id="display"
                  cellRenderer={(rowIndex) => (<Cell>{data[rowIndex]["display"] ? <Icon intent="success" icon="tick" /> : <Icon icon="cross" intent="danger" />}</Cell>)}
                  columnHeaderCellRenderer={(index) => {
                    return <ColumnHeaderCell2 name={<Trans>display</Trans>} index={index} nameRenderer={this.renderName} />;
                  }}
                /> */}

                {/* intent */}
                <Column
                  id="intent"
                  cellRenderer={(rowIndex) => {
                    switch (data[rowIndex]["intent"]) {
                      case "primary":
                        return <Cell><Tag intent="primary" fill={true} style={{ textAlign: "center" }}>primary</Tag></Cell>;
                      case "success":
                        return <Cell><Tag intent="success" fill={true} style={{ textAlign: "center" }}>sucess</Tag></Cell>;
                      case "warning":
                        return <Cell><Tag intent="warning" fill={true} style={{ textAlign: "center" }}>warning</Tag></Cell>;
                      case "danger":
                        return <Cell><Tag intent="danger" fill={true} style={{ textAlign: "center" }}>danger</Tag></Cell>;
                      case "normal":
                      default:
                        return <Cell><Tag intent="normal" fill={true} style={{ textAlign: "center" }}>normal</Tag></Cell>;
                    }

                  }}
                  columnHeaderCellRenderer={(index) => {
                    return <ColumnHeaderCell name={<Trans>intent</Trans>} index={index} nameRenderer={this.renderName} />;
                  }}
                />

                {/* edit */}
                <Column
                  cellRenderer={(rowIndex) =>
                    <Cell>
                      <Tag
                        icon="cog"
                        minimal={true}
                        fill={true}
                        interactive={true}
                        onClick={() => this.setState({
                          editing: true,
                          edit: rowIndex,
                          edit_display: data[rowIndex]["display"],
                          edit_intent: data[rowIndex]["intent"]
                        })}
                      ><Trans>edit</Trans>
                      </Tag>
                    </Cell>
                  }
                  columnHeaderCellRenderer={(index) => {
                    return <ColumnHeaderCell index={index} />;
                  }}
                />
              </Table2>

              <Alert
                isOpen={this.state.editing}
                onClose={() => this.setState({ editing: false })}
                canEscapeKeyCancel={true}
                canOutsideClickCancel={true}
                intent={data[this.state.edit] && data[this.state.edit]["intent"]}
                icon="cog"
                title={data[this.state.edit] && i18n.t("event" + data[this.state.edit]["id"])}
                onConfirm={() => {
                  authenticatedPutFetch("/event",
                    {
                      ...data[this.state.edit],
                      eventId: data[this.state.edit]["id"],
                      display: this.state.edit_display,
                      intent: this.state.edit_intent
                    },
                    () => {
                      this.setState({
                        events: data.map(event => {
                          if (event.id === data[this.state.edit]["id"])
                            return {
                              ...data[this.state.edit],
                              eventId: data[this.state.edit]["id"],
                              display: this.state.edit_display,
                              intent: this.state.edit_intent
                            };
                          else
                            return event;
                        })
                      })
                    })
                }}
              >
                {data[this.state.edit] &&
                  <div className={Classes.ALERT_CONTENTS}>
                    <Trans>event</Trans> n°{data[this.state.edit]["id"]}

                    <Select
                      filterable={false}
                      items={["normal", "primary", "success", "warning", "danger"]}
                      itemRenderer={(item, { select, modifiers }) => {
                        return <MenuItem
                          active={item === select}
                          key={item}
                          text={<Tag intent={item}>{item}</Tag>}
                          onClick={() => { this.setState({ edit_intent: item }); }}
                        />;
                      }}
                    >
                      <Button rightIcon="double-caret-vertical">
                        <Tag intent={this.state.edit_intent}>
                          <Trans>{this.state.edit_intent}</Trans>
                        </Tag>
                      </Button>
                    </Select>
                  </div>}
              </Alert>
            </div>
          </div> :
          <Callout intent="warning">
            <Trans>you are not allowed to visualize element</Trans>
            <Trans>for any change of your permissions please contact an administrator</Trans>
          </Callout>
      }
    </div >
  }
}

export default withTranslation()(EventFiltersSetting)
